/* istanbul ignore next */
const ACTIONS = {
    CONFIRM_BRAND: 'CONFIRM_BRAND',
    SELECT_ACCOUNT: 'SELECT_ACCOUNT',
    MULTIPLE_ACCOUNTS_SELECTION_ERROR: 'MULTIPLE_ACCOUNTS_SELECTION_ERROR',
    DISMISS_ALERT_BOX: 'DISMISS_ALERT_BOX'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    selectAccount(selectedAccountDetails) {
        return {
            type: ACTIONS.SELECT_ACCOUNT,
            payload: {
                selectedAccountDetails
            }
        };
    },
    alertError(errorKey) {
        return {
            type: ACTIONS.MULTIPLE_ACCOUNTS_SELECTION_ERROR,
            payload: {
                errorKey
            }
        };
    },
    dismissAlertBox() {
        return {
            type: ACTIONS.DISMISS_ALERT_BOX
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
